<template>
	<div :class="portalClass">
		<alert-container></alert-container>
		<header role="banner">
			<a
				v-if="!expanded" class="primary-nav" href="#primary-nav"
				@click.prevent="showNav = !showNav">Navigation</a>
			<h1>
				<router-link :to="{name: 'dashboard'}" class="dashboard"><span>Dashboard</span></router-link>
			</h1>
			<nav id="primary-nav">
				<ul>
					<li><router-link :to="{name: 'dashboard'}" class="dashboard"><span>Dashboard</span></router-link>
					</li>
					<li><router-link :to="{name: 'tasks.index'}"><span>Tasks <span
						:class="linkCountClass($store.getters.incompleteTasks().length)"
						class="link-count"
						v-html="$store.getters.incompleteTasks().length"/></span></router-link></li>
					<li><router-link :to="{name: 'documents.index'}"><span>Documents</span></router-link></li>
					<li><router-link :to="{name: 'invoices.index'}"><span>Invoices
						<span
							:class="linkCountClass(outstandingInvoices.length)"
							class="link-count"
							v-html="outstandingInvoices.length"/></span>
					</router-link></li>
				</ul>
			</nav>
			<div class="banner__header">
				<div class="flex gap-1 items-center">
					<ul v-if="nextTask || remainingTasks">
						<li>
							<button
								class="button button--primary--small" @click.prevent="showNextTaskModal()">What's Next?
							</button>
						</li>
					</ul>
					<v-contextual-content>
						<template v-slot:trigger="{ toggle }">
							<button @click="toggle" v-html="$present('initials', $authed())"/>
						</template>
						<div class="section section--floating">
							<div class="account__dropdown__auth-summary">
								<figure>
									<figcaption v-html="$present('initials', $authed())"/>
								</figure>
								<dl>
									<dt>User</dt>
									<dd class="beta heavy">
										<nobr v-html="$present('fullName', $authed())"/>
									</dd>
									<dd class="text--light" v-html="$authed().email"/>
								</dl>
							</div>
							<ul class="actions actions--right content-between">
								<li v-if="!detect.device.isMobile">
									<button class="auto-login" @click="showQrModal()"><span>Switch To Phone</span>
									</button>
								</li>
								<li>
									<a
										class="button button--primary--small"
										href="/logout">Sign Out</a>
								</li>
							</ul>
						</div>
					</v-contextual-content>
				</div>
			</div>
		</header>
		<main role="main">
			<div>
				<slot/>
			</div>
		</main>
		<vmodal :defaultOptions="defaultModalOptions" :options="modalOptions"/>
	</div>
</template>
<script>
import VContextualContent from "../../../common/components/v-contextual/v-contextual-content";
import essentialTasks from "../mixins/essentialTasks";
import invoices from "../mixins/invoices";
import watchesWindowResizeEvent from "../../../mixins/watchesWindowResizeEvent";
import watchesRouteChanged from "../../../mixins/watchesRouteChanged";

export default {
	components: {
		VContextualContent,
	},

	mixins: [
		essentialTasks,
		invoices,
		watchesWindowResizeEvent,
		watchesRouteChanged,
	],

	data() {
		return {
			expanded: false,
			showNav: false,
			timeout: null,
			routerViewKey: 0,
			defaultModalOptions: {
				component: require("../../../components/v-modal").default,
				opacity: "1",
				backgroundColor: "rgba(45, 51, 61, .85)",
				animation: "slideBottom",
			},
		};
	},

	props: {
		modalOptions: {
			required: true,
			default() {
				return {};
			},
		},
	},

	computed: {
		nextTask() {
			return this.$store.getters.nextTask();
		},
		remainingTasks() {
			return this.$store.getters.remainingTasks();
		},
		portalClass() {
			return {
				"expanded": this.expanded,
				"nav-on": this.showNav,
			};
		},
	},

	methods: {
		routeChanged() {
			this.showNav = false;
		},
		windowResized({innerWidth}) {
			let threshold = innerWidth >= 1024;
			this.expanded = threshold;
			this.showNav = !threshold ? this.showNav : false;
		},
		showQrModal() {
			this.$vmodal.open({
				component: require("../modals/AutoLogin.vue").default,
				props: {
					qrCode: this.$authed().qrCode,
				},
			});
		},
		linkCountClass(count) {
			return {
				"link-count--positive": count > 0,
			};
		},
	},
};
</script>
